import React from "react";
import { connect } from "react-redux";
import { NavLink, Link } from "react-router-dom";
import { getUsuario } from "../usuario/UsuarioService";
import axios from "axios";
import { URL, admin, getAuthorizationHeader, verificarRol, gestionLegajos } from "../../constans/constants";
import "../../styles/Empresa.css";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import { subirArchivoCsv } from "../usuario/UsuarioService";
import Cookies from "universal-cookie";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { logout } from "../login/SesionService";
import { obtenerListaEmpresas } from "../empresas/EmpresaService";
import { obtenerRolesEmpresaDatos } from "../usuario/UsuarioService";
import BreadCrumComponent from "../componentes/BreadCrumComponent";
import TablaItemsConfiguracion from "../componentes/tablas/TablaItemsConfiguracion";
import ModalEliminarConDetalles from "../componentes/modales/ModalEliminarConDetalles.js";
import ModalDetalleUsuario from "../componentes/modales/ModalDetalleUsuario.js";

export const obtenerIdEmpresa = () => {
  const cookies = new Cookies();
  return cookies.get("empresa");
};
export const esSesionAdmin = () => {
  const cookies = new Cookies();
  return cookies.get("admin") == "true";
};

class Usuarios extends React.Component {
  constructor(props) {
    super(props);

    const { location } = this.props;
    const estado = location && location.state ? location.state : {};

    this.state = {
      usuarioSeleccionado: null,
      file: null,
      filename: "",
      fileErrorMsg: "",
      dialogImportFromArchivo: false,
      dialogIsOpen: false,
      dialogIsOpenVerDatos: false,
      open: false,
      roles: [],
      openPantallaCarga: false,
      severity: "success",
      listaEmpresas: null,
      listaEmpresaSelected: null,
      openMsgFailVentana: false,
      openMsgFinImportacion: false,
      erroresCsv: [],
      cantidadImportados: null,
      ultimoUsuarioImportado: null,

      mensajeFlash: estado.mensajeFlash || "",
      mostrarMensajeFlash: estado.mostrarMensajeFlash || false,
      mensajeFlashSeverity: estado.mensajeFlashSeverity || "neutral",
    };
    this.modalRef = React.createRef(); //referencia al modal
    this.tablaRef = React.createRef(); //referencia a la tabla de elementos
    this.modalEliminarRef = React.createRef();
  }

  componentDidMount() {
    if (esSesionAdmin()) {
      obtenerListaEmpresas().then((res) => {
        this.state.listaEmpresas = res.datos;
        this.state.listaEmpresaSelected = res.datos[0].id;
      });
    }
  }

  handleDialog = (value, mensaje = "", severity) => {
    if (value === false) {
      if (mensaje != "") {
        this.setState({
          mostrarMensajeFlash: true,
          mensajeFlash: mensaje,
          severity: severity,
        });
      }
    }
    this.setState({ dialogIsOpen: value });
  };

  handleDialogVerDatos = (value, usuarioSeleccionado = null) => {
    this.setState({ dialogIsOpenVerDatos: value }, () => {
      if (value && usuarioSeleccionado && this.modalRef) {
        this.modalRef.cargarDetalles(usuarioSeleccionado);
      }
    });
  };

  handleClickOpen = (usuario = null) => {
    this.setState({
      open: true,
      usuarioSeleccionado: usuario,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  handleDialogImportarUsuarios = () => {
    this.props.history.push(!esSesionAdmin() ? "/administracion/usuarios/importar" : "/admin/usuarios/importar");
  };

  descargarXls = () => {
    let empresa = esSesionAdmin() ? -200 : obtenerIdEmpresa();
    window.location.href = URL + "usuario/xls/" + empresa;
  };

  handleDisableUsuario = () => {
    this.modalEliminarRef.cerrarModalConAnimacion();
    this.setState({ openPantallaCarga: true });
    let empresa = obtenerIdEmpresa() != null ? obtenerIdEmpresa() : 0;
    let usuarioSeleccionado = this.state.usuarioSeleccionado;
    axios
      .get(
        URL +
        "usuario/" +
        usuarioSeleccionado.usuario +
        "/desactivar/empresa/" +
        empresa,
        getAuthorizationHeader()
      )
      .then(
        (response) => {
          this.setState({
            openPantallaCarga: false,
            mostrarMensajeFlash: true,
            mensajeFlash: response.data.mensaje,
            mensajeFlashSeverity: response.data.error ? "error" : "exito",
          });
          this.actualizarDatosTabla();
        },
        (error) => {
          if (error.response.status === 401) {
            logout();
          }
          return error;
        }
      );
  };

  handleNewUsuario = () => {
    this.props.history.push("/administracion/usuarios/add");
  };

  handleEditarUsuario = (datos) => {
    this.props.history.push({
      pathname: "/administracion/usuarios/edit",
      state: { usuario: datos },
    });
  };

  fetchUsuarios = (page, pageSize, search) => {
    return this.props.getUsuario(page, pageSize, search).then(() => {
      const { usuariosData } = this.props;
      return {
        items: usuariosData.usuarios,
        totalCount: usuariosData.totalCount,
      };
    });
  };

  renderFilas = (filas) => {
    return filas.map((f) => (
      <tr key={f.identificador}>
        <td>{f.identificador}</td>
        <td>{f.nombreApellido}</td>
        <td>{f.usuario}</td>
        <td>{f.email}</td>
        <td>
          <div className="table-actions">
            <button
              className="table-icon open-dialog"
              data-dialog="modal-detalle-documento"
              data-id={f.id}
              onClick={() => this.handleDialogVerDatos(true, f)}
            >
              <span className="material-symbols-outlined"> visibility </span>
            </button>
            <button
              className="table-icon"
              onClick={() => this.handleEditarUsuario(f)}
            >
              <span className="material-symbols-outlined"> edit </span>
            </button>
            <button
              className="table-icon open-dialog"
              data-dialog="modal-delete-details"
              data-id={f.id}
              onClick={() => this.handleClickOpen(f)}
            >
              <span className="material-symbols-outlined"> delete </span>
            </button>
          </div>
        </td>
      </tr>
    ));
  };

  actualizarDatosTabla = () => {
    if (this.tablaRef) {
      this.tablaRef.fetchData();
    }
  };

  renderHeadArea = () => (
    <div className="head-area">
      <div className="caption-area">
        <h1 className="page-title"> Gestión de usuarios </h1>
        <p className="page-description">
          {" "}
          Desde este menú puede gestionar los usuarios de su compañía
        </p>
      </div>
      <div className="head-actions">
        <button
          onClick={this.descargarXls}
          className="btn-medium btn-base-outline"
        >
          {" "}
          Descargar XLS{" "}
        </button>
        <button
          onClick={() => this.handleDialogImportarUsuarios()}
          className="btn-medium btn-primary-tonal"
        >
          {" "}
          Importar Usuarios{" "}
        </button>
        <button
          onClick={() => this.handleNewUsuario()}
          className="btn-medium btn-primary"
        >
          {" "}
          <span className="material-symbols-outlined">
            {" "}
            person_add_alt{" "}
          </span>{" "}
          Nuevo Usuario{" "}
        </button>
      </div>
    </div>
  );

  renderTabla = () => (
    <div className="wrapperContent">
      <div className="page-container">
        <TablaItemsConfiguracion
          ref={(ref) => (this.tablaRef = ref)}
          titulo="Lista de usuarios"
          headers={[
            "Identificador",
            "Nombre y apellido",
            "Nombre de usuario",
            "E-mail",
            "Acciones",
          ]}
          fetchDatos={this.fetchUsuarios}
          renderFilas={this.renderFilas}
        />
      </div>
    </div>
  );

  render() {
    return (
      <div>
        {admin() ? (
          <>
            <header className="component-header">
              <div className="page-container">{this.renderHeadArea()}</div>
            </header>
            {this.renderTabla()}
          </>
        ) : (
          <div className="template-base">
            <header className="component-header">
              <div className="page-container">
                <BreadCrumComponent
                  backUrl={"/bandeja/pendientes"}
                  breadcrumbs={[
                    { label: "Menu principal", path: "/bandeja/pendientes" },
                  ]}
                />
                <nav className="nav-area">
                  <NavLink to="/administracion/usuarios" className="nav-link">
                    <span className="material-symbols-outlined">
                      {" "}
                      account_circle{" "}
                    </span>{" "}
                    Usuarios
                  </NavLink>
                  <NavLink to="/administracion/grupos" className="nav-link">
                    <span className="material-symbols-outlined">
                      {" "}
                      supervised_user_circle{" "}
                    </span>{" "}
                    Grupos de usuarios
                  </NavLink>
                  {verificarRol(JSON.parse(localStorage.getItem("roles")), [
                    gestionLegajos,
                  ]) && (
                    <NavLink to="/administracion/legajos" className="nav-link">
                      <span className="material-symbols-outlined">
                        {" "}
                        assignment_ind{" "}
                      </span>{" "}
                      Legajos
                    </NavLink>
                  )}
                  {verificarRol(JSON.parse(localStorage.getItem("roles")), [
                    gestionLegajos,
                  ]) && (
                    <NavLink
                      to="/administracion/vacaciones"
                      className="nav-link"
                    >
                      <span className="material-symbols-outlined">
                        beach_access
                      </span>
                      Vacaciones
                    </NavLink>
                  )}
                </nav>
                {this.renderHeadArea()}
              </div>
            </header>
            {this.renderTabla()}
          </div>
        )}
          <ModalDetalleUsuario
            ref={(ref) => (this.modalRef = ref)}
            abierto={this.state.dialogIsOpenVerDatos}
            onClose={() => this.handleDialogVerDatos(false)}
            fetchDetalle={obtenerRolesEmpresaDatos}
            titulo="Datos del usuario"
            renderContenido={(datos, empresaRoles) => (
              <div className="card">
                <p className="section__subtitle">
                  {" "}
                  {datos.nombreApellido?.trim() || "--"}{" "}
                </p>

                <div className="card-content">
                  <div className="content-inner">
                    <span className="label"> Nombre de usuario </span>
                    <span className="txt">
                      {" "}
                      {datos.usuario?.trim() || "--"}{" "}
                    </span>
                  </div>
                  <div className="content-inner">
                    <span className="label"> Nro. IPS Patronal </span>
                    <span className="txt">
                      {" "}
                      {datos.nroPersonalIps?.trim() || "--"}{" "}
                    </span>
                  </div>
                  <div className="content-inner">
                    <span className="label"> Nro. Trabajo MTESS </span>
                    <span className="txt">
                      {" "}
                      {datos.nroTrabajoMtess?.trim() || "--"}{" "}
                    </span>
                  </div>
                  <div className="content-inner">
                    <span className="label"> Cédula de identidad </span>
                    <span className="txt">{datos.cedula?.trim() || "--"}</span>
                  </div>
                  <div className="content-inner">
                    <span className="label"> Teléfono </span>
                    <span className="txt">
                      {" "}
                      {datos.celular?.trim() || "--"}{" "}
                    </span>
                  </div>
                  <div className="content-inner">
                    <span className="label"> Identificador </span>
                    <span className="txt">
                      {" "}
                      {datos.identificador?.trim() || "--"}{" "}
                    </span>
                  </div>
                  <div className="content-inner">
                    <span className="label"> E-mail </span>
                    <span className="txt"> {datos.email?.trim() || "--"}</span>
                  </div>
                  {empresaRoles[0] &&
                    <div className="content-inner">
                      <span className="label"> Empresa </span>
                      <span className="label__success">
                        {" "}
                        {empresaRoles[0].nombre?.trim() || "--"}{" "}
                      </span>
                    </div>
                  }
                </div>
                {empresaRoles[0] &&
                  <div className="content-inner">
                    <span className="label"> Roles asignados </span>
                    {empresaRoles == null ? (
                      <span className="txt">
                        {" "}
                        No se pudo recuperar informacion de roles
                      </span>
                    ) : (
                      <div className="row__labels">
                        {empresaRoles[0].roles.map((elemento) => {
                          if (elemento.checked)
                            return (
                              <span key={elemento.id} className="label__info">
                                {elemento.nombre}
                              </span>
                            );
                        })}
                      </div>
                    )}
                  </div>
                }
              </div>
            )}
          />
        <MensajeFlash
          visible={this.state.mostrarMensajeFlash}
          mensaje={this.state.mensajeFlash}
          severity={this.state.mensajeFlashSeverity}
        />

        <ModalEliminarConDetalles
          ref={(ref) => (this.modalEliminarRef = ref)}
          isOpen={this.state.open}
          cerrarModal={this.handleClose}
          onConfirmar={this.handleDisableUsuario}
          elemento={this.state.usuarioSeleccionado}
          titulo="usuario"
          detallesAMostrar={[
            { clave: "identificador", etiqueta: "Identificador" },
            { clave: "nombreApellido", etiqueta: "Nombre del usuario" },
          ]}
          mensaje="Esta acción eliminará el usuario seleccionado."
          textoBotonAccion="CONFIRMAR ELIMINACIÓN"
        />

        <PantallaCarga mensaje={"Procesando"} />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getUsuario: (page, size, search) => dispatch(getUsuario(page, size, search)),
  subirArchivoCsv: (file, idEmpresa) =>
    dispatch(subirArchivoCsv(file, idEmpresa)),
});

const mapStateToProps = (state) => ({
  usuariosData: state.usuariosData,
});

export default connect(mapStateToProps, mapDispatchToProps)(Usuarios);
